<template>
	<div
		class="relatedReading"
		:style="{
			marginTop: data.marginTop + 'px',
			paddingTop: data.paddingTop + 'px',
			paddingLeft: data.paddingLeft + '%',
			paddingRight: data.paddingRight + '%',
		}"
	>
		<div v-if="data.content || data.data.length > 0">
			<div
				class="example-3d haibao"
				:style="{
					backgroundImage: 'url(' + (data.backgroundImage == '' ? 'https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_25/lhyy_box.jpg' : data.backgroundImage) + ')',
				}"
			>
				<swiper class="swiper" :options="swiperOption_lhyy" ref="mySwiper">
					<swiper-slide v-for="(item, index) in data.data" :key="index" style="perspective: 1000px" :data-index="index">
						<div class="swiper-img-box">
							<img :src="item.Simg" class="swiper-img" />
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>

		<div v-else>
			<div class="example-3d haibao">
				<swiper class="swiper">
					<swiper-slide style="perspective: 1000px">
						<div class="swiper-img-box">
							<img src="https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_25/haibao_1.png" class="swiper-img" />
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>

		<van-image-preview class="BigItemImg" v-model="popupImg" :showIndex="false" :overlayStyle="{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }" :images="[previewImg]" @close="closeBigImg">
			<template v-slot:cover><span @click="pictureDownload">保存图片</span></template>
		</van-image-preview>
	</div>
</template>

<script>
let vm = null;
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
	name: 'productDisplay',
	props: ['data'],
	components: {
		swiper,
		swiperSlide,
	},

	data() {
		return {
			popupImg: false,
			previewImg: '',
			swiperOption_lhyy: {
				loop: true, //无线循环
				effect: 'coverflow', //设置Slide的切换效果
				grabCursor: true, //该选项给Swiper 使用者提供小小的贴心应用，设置为true 时，鼠标覆盖Swiper 时指针会变成手掌形状，拖动时指针会变成抓手形状。（根据浏览器形状有所不同）
				centeredSlides: true, //居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
				slidesPerView: 'auto',
				coverflowEffect: {
					rotate: 0,
					stretch: 45, //每个slide之间的拉伸值，越大slide靠得越紧  默认0
					depth: 200, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
					modifier: 1,
					slideShadows: false, //开启slide阴影。默认 true。
					observeParents: true, //监测Swiper 的祖/父元素
				},
				on: {
					click: function (e) {
						// 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
						// console.log(this); // -> Swiper
						// 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。
						const realIndex = this.realIndex;
						vm.seeBigImg(vm.data.data[realIndex].Bimg);
					},
				},
			},
		};
	},
	computed: {
		swiper() {
			return this.$refs.mySwiper.swiper;
		},
	},
	created() {
		vm = this;
	},
	methods: {
		//查看大图
		seeBigImg(imgSrc) {
			this.popupImg = true;
			this.previewImg = imgSrc;
		},
		//关闭查看大图
		closeBigImg() {
			setTimeout(() => {
				this.previewImg = '';
			}, 500);
		},
		//下载图片
		pictureDownload() {
			this.$bridge.callHandler('savePicture', { url: this.previewImg, title: '' }, function (response) {});
		},
	},
};
</script>

<style lang="scss" scoped>
.example-3d {
	width: 100%;
	overflow: hidden;
	background-repeat: no-repeat;
	background-size: 100% 100%;
}
.haibao {
	background-image: url('https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_25/haibao.jpg');
	padding-top: 80px;
}
/* swiper */
.swiper {
	width: 80%;
}
.swiper-img-box {
	height: 100%;
	width: 100%;
	transform-style: preserve-3d;
	transform-origin: center;
	background-size: 100%;
}

.haibao .swiper-slide {
	display: flex;
	width: 150px;
	height: 250px;
}
.haibao .swiper-img {
	position: absolute;
	width: 150px;
	height: 220px;
	background-size: cover;
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden; /* Chrome 、Safari */
}
.haibao .swiper-slide-active img {
	margin-top: 5px;
}
.haibao ::v-deep .swiper-slide:not(.swiper-slide-active):not(.swiper-slide-prev):not(.swiper-slide-next) {
	opacity: 0;
}

::v-deep .van-image-preview__cover {
	position: absolute;
	left: 50%;
	color: #fff;
	font-size: 0.875rem;
	line-height: 1.25rem;
	text-shadow: 0 0.0625rem 0.0625rem #323233;
	-webkit-transform: translate(-50%, 0);
	transform: translate(-50%, 0);
	top: auto;
	bottom: 5%;
	span {
		font-size: 12px;
		background-color: rgba(0, 0, 0, 0.6);
		padding: 8px 14px;
		border-radius: 4px;
		letter-spacing: 1px;
	}
}

.BigItemImg ::v-deep .van-image__img {
	width: 80%;
	margin: 0 auto;
}
</style>